import React from 'react';
import { Diff } from '../Diff';
import { getDiff, getComparePresetLabel } from '../../model/Diff';
import { UnitsIcon } from '../icons/UnitsIcon';
import { ComparePreset } from '../../model/datePicker/types';

const Units = ({ value, previousValue, comparePreset }: Props) => {
  return (
    <div className="d-flex flex-column">
      <small className="mb-2 text-gray-12">Units</small>
      <div className="d-flex align-items-center">
        <UnitsIcon />
        <h1 className="ms-2 mb-0 text-gray-12">{Math.round(value)}</h1>
      </div>
      <div className="mt-2">
        <small className="d-flex align-items-center" style={{ marginTop: 1 }}>
          <Diff value={getDiff(value, previousValue)} />
          <div className="text-gray-12 fs-7">{getComparePresetLabel(comparePreset)} ({Math.round(previousValue)})</div>
        </small>
      </div>
    </div>
  );
}

interface Props {
  value: number,
  previousValue: number,
  comparePreset?: ComparePreset
}

export { Units };